<template>
  <div>
    <!-- (12位) -->
    <div style="margin-left: 40px">
      <el-button
        size="medium"
        type="primary"
        @click="(excelVisible = true), (errorLabel = [])"
        :close-on-click-modal="false"
        >导入箱子<i class="el-icon-upload el-icon--right"></i
      ></el-button>
      <el-tooltip
        class="item"
        effect="dark"
        placement="top-start"
        style="margin-right: 10px"
      >
        <div slot="content">
          系统会自动根据箱数和FBAID生成对应的箱号<br />
          输出比如FBA15M7CJDZN箱数为3，系统会自动生成对应的箱号明细数据<br />
          FBA15M7CJDZU000001<br />
          FBA15M7CJDZU000002<br />
          FBA15M7CJDZU000003<br />
          注：如果使用页面录入货物信息，需录入对应箱子信息
        </div>
        <span
          style="font-size: 14px; color: #f9a123"
          class="el-icon-question"
        ></span>
      </el-tooltip>

      <!-- <el-button
        size="medium"
        type="primary"
        @click="(excelVisibleUpadte = true), (errorLabel = [])"
        :close-on-click-modal="false"
        >导入箱子(19位)<i class="el-icon-upload el-icon--right"></i
      ></el-button> -->
    </div>
    <div style="width: 100%; float: left">
      <el-form
        label-position="left"
        class="demo-dynamic"
        size="mini"
        :model="ruleform"
        ref="ruleform"
      >
        <div
          class="cardWrap"
          v-for="(item, index) in ruleform.formLIst"
          :key="index"
        >
          <div class="box-card">
            <div class="card_header">
              <div class="boxindex">
                {{ index + 1 }}
              </div>
              <div class="header_logo" style="cursor: pointer">
                <div class="cloneType" @click="clone(item)">复制</div>
                <div
                  class="deleteBtn"
                  v-if="ruleform.formLIst.length > 1"
                  @click="handleDelete(index, item)"
                >
                  <i class="el-icon-error"></i>
                </div>
              </div>
              <div class="">
                <el-row :gutter="5" class="">
                  <el-col :span="12">
                    <el-col :span="12">
                      <el-form-item
                        label="尺寸(CM)"
                        label-width="86px"
                        class="rules"
                        :prop="'formLIst.' + index + '.length'"
                        :rules="moreNotOjb.Notlength"
                      >
                        <el-input
                          placeholder="长"
                          size="mini"
                          :min="0"
                          :max="9999"
                          v-model="item.length"
                          @change="getTimoney(index), getFBATrans(index)"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item
                        class="rules"
                        label-width="5px"
                        :prop="'formLIst.' + index + '.width'"
                        :rules="moreNotOjb.Notwidth"
                      >
                        <el-input
                          placeholder="宽"
                          size="mini"
                          :min="0"
                          :max="9999"
                          v-model="item.width"
                          @change="getTimoney(index), getFBATrans(index)"
                        >
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item
                        label-width="5px"
                        class="rules"
                        :prop="'formLIst.' + index + '.height'"
                        :rules="moreNotOjb.Notheight"
                      >
                        <el-input
                          placeholder="高"
                          size="mini"
                          :min="0"
                          :max="9999"
                          v-model="item.height"
                          @change="getTimoney(index), getFBATrans(index)"
                        >
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-col>
                  <el-col :span="5">
                    <div
                      class="LR_center"
                      style="
                        font-size: 12px;
                        font-weight: bold;
                        text-align: left;
                        margin-top: 8px;
                      "
                    >
                      <div style="">
                        <span style="color: #f86670">{{ item.cbm }}</span
                        >CBM
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
            <div class="card_count">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item
                    class="rules"
                    label-width="95px"
                    label="客户箱号"
                    :rules="moreNotOjb.Notboxnum"
                    :prop="'formLIst.' + index + '.fbxBoxNo'"
                  >
                    <el-input
                      maxlength="19"
                      type="text"
                      :placeholder="
                        billType ? '示例：FBAXXXXX (共19位)' : '请输入箱号'
                      "
                      v-model="item.fbxBoxNo"
                      size="mini"
                    >
                      <el-button
                        v-if="billType"
                        slot="suffix"
                        @click="(imageNum = 1), (imagesType = true)"
                        type="text"
                        >示例图</el-button
                      >
                    </el-input>
                  </el-form-item>
                  <span class="Shipment">(Shipment ID)</span>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label-width="95px"
                    class="rules"
                    label="重量"
                    :prop="'formLIst.' + index + '.weight'"
                    :rules="moreNotOjb.Notweight"
                  >
                    <el-input
                      size="mini"
                      @change="getTimoney(), getFBATrans(index)"
                      :min="0"
                      :max="999"
                      v-model="item.weight"
                      placeholder="请输入重量"
                    >
                      <i slot="suffix">(KG)</i>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col
                  :span="12"
                  v-if="billType && toFABck.countryCode == 'SA'"
                >
                  <el-form-item
                    class="rules"
                    label-width="95px"
                    label="商铺编号"
                    :prop="'formLIst.' + index + '.shopName'"
                    :rules="moreNotOjb.Notgoodsnum"
                  >
                    <el-input v-model="item.shopName" size="mini"></el-input>
                  </el-form-item>
                </el-col>
                <el-col
                  :span="12"
                  v-if="
                    (billType && toFABck.countryCode == 'SA') ||
                    (billType && toFABck.countryCode == 'US') ||
                    (billType && toFABck.countryCode == 'EU') ||
                    (billType && toFABck.countryCode == 'GB')
                  "
                >
                  <el-form-item
                    class="rules"
                    label-width="110px"
                    label="货件追踪编号"
                    :prop="'formLIst.' + index + '.poTrackingNo'"
                    :rules="moreNotOjb.Notponum"
                  >
                    <el-input
                      size="mini"
                      maxlength="8"
                      v-model="item.poTrackingNo"
                      placeholder="示例：618T8E8X"
                    >
                      <el-button
                        slot="suffix"
                        @click="(imageNum = 2), (imagesType = true)"
                        type="text"
                        >示例图</el-button
                      >
                    </el-input>
                  </el-form-item>
                  <span class="ShipmentID">(Reference ID)</span>
                </el-col>
              </el-row>
            </div>
            <div style="width: 100%; padding: 5px 20px; box-sizing: border-box">
              <el-collapse
                @change="handleOPen(index)"
                v-model="activeName"
                style="float:left:width:100%"
              >
                <el-collapse-item :name="index">
                  <template slot="title">
                    <i class="el-icon-coin"></i>
                    <span
                      style="
                        margin-left: 15px;
                        font-size: 13px;
                        font-weight: bold;
                      "
                      >{{ item.goodsDTOList.length }}箱商品</span
                    >
                    <span
                      class="el-icon-info"
                      style="margin-left: 30px; font-size: 12px; color: #999"
                      >请根据实际情况填写商品货值</span
                    >
                  </template>
                  <div
                    @click="clickme(_item)"
                    class="goodLi"
                    style="width: 100%"
                    v-for="(_item, _index) in item.goodsDTOList"
                    :key="_index"
                  >
                    <div style="width: 30px; float: left">
                      <i
                        style="font-size: 18px"
                        class="el-icon-shopping-cart-1"
                      ></i>
                    </div>
                    <div
                      style="
                        width: 280px;
                        float: left;
                        overflow: hidden;
                        color: #999999;
                        font-weight: bold;
                        font-size: 12px;
                      "
                    >
                      <span style="width: 100px">{{ _item.namec }} </span>
                      <span style="margin-left: 10px">({{ _item.namee }})</span>
                    </div>
                    <div
                      style="float: left; margin-left: 10px"
                      class="handNumber"
                    >
                      <el-input
                        size="mini"
                        v-model.number="_item.num"
                        type="number"
                        minlength="1"
                        maxLength="9"
                        oninput="if(isNaN(value)) { value = null } if(value<=0) {value=null} if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}"
                      >
                        <i
                          slot="suffix"
                          class="el-input__icon el-icon-plus"
                          @click="(_item.num += 1), Changehandle()"
                        ></i>
                        <i
                          slot="prefix"
                          class="el-input__icon el-icon-minus"
                          @click="
                            (_item.num -= 1),
                              _item.num <= 1 ? (_item.num = 1) : '',
                              Changehandle()
                          "
                        ></i>
                      </el-input>
                    </div>
                    <div
                      class="goodsValue"
                      style="float: left; margin-left: 10px"
                    >
                      <span style="color: #999">货值(USD)</span>
                      <el-input
                        style="width: 150px; border: none"
                        size="mini"
                        v-model="_item.declaredValue"
                        placeholder="货值"
                      >
                      </el-input>
                    </div>
                    <div style="float: left; margin-left: 10px">
                      <el-button
                        class="el-icon-delete"
                        style="color: #f86670"
                        type="text"
                        size="mini"
                        @click="delBoxgood(index, _index)"
                        >删除</el-button
                      >
                    </div>
                  </div>
                </el-collapse-item>
              </el-collapse>
              <!-- 折叠END -->
              <div class="addStyle">
                <el-button
                  plain
                  icon="el-icon-circle-plus-outline"
                  size="mini"
                  style="border-radius: 2px"
                  circle
                  @click="changegoods(index)"
                  >选择商品</el-button
                >
              </div>
            </div>
          </div>
        </div>
      </el-form>
      <!-- demo 测试 END -->
    </div>
    <div style="width: 35%; float: left; padding: 30px" class="LR_center">
      <div>
        <el-button size="medium" @click="addItem('ruleform')"
          >+新增箱子</el-button
        >
      </div>
    </div>

    <!-- 商品列表 -->
    <el-dialog title="商品列表" width="950px" :visible.sync="goodsTypeShow">
      <div class="typeHeader LR_center">
        <div>
          <el-input
            style="width: 314px"
            placeholder="请输入中文品名"
            v-model="Sgodname"
            class="input-with-select"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              type="primary"
              @click="getgoodsData(Sgodname)"
              >搜索</el-button
            >
          </el-input>
        </div>
        <div>
          <el-select
            clearable
            style="width: 100%"
            ref="changeFBAgoodtype"
            placeholder="请选择商品类型"
            v-model="ThatgoodsID"
            @change="getgoodsData(Sgodname)"
          >
            <el-option
              v-for="res in goodstypelist"
              :key="res.id"
              :label="res.cnName"
              :value="res.id"
            ></el-option>
          </el-select>
        </div>
        <div>
          <el-button
            type="primary"
            icon="el-icon-plus"
            plain
            @click="addgoods()"
            >新增商品</el-button
          >
        </div>
      </div>

      <div class="countTable" style="margin-top: 30px">
        <el-table
          ref="multipleTable"
          border
          :data="goodsLabel"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column label="中文名称" align="center" width="120">
            <template slot-scope="scope">{{ scope.row.namec }}</template>
          </el-table-column>
          <el-table-column
            prop="namee"
            label="英文品名"
            align="center"
            width="120"
          >
          </el-table-column>
          <el-table-column prop="materialc" align="center" label="中文材质">
          </el-table-column>
          <el-table-column prop="purposec" align="center" label="用途">
          </el-table-column>
          <el-table-column prop="hsCode" align="center" label="海关编码">
          </el-table-column>
          <el-table-column prop="goodstype" align="center" label="货物类型">
          </el-table-column>
          <el-table-column prop="goodstype" align="center" label="是否带电">
            <template slot-scope="scope">
              {{ scope.row.isHasBattery ? "是" : "否" }}
            </template>
          </el-table-column>
          <el-table-column
            prop="goodstype"
            align="center"
            label="是否液体/粉末"
          >
            <template slot-scope="scope">
              {{ scope.row.isPowderLiquid ? "是" : "否" }}
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="120">
            <template slot-scope="scope" v-if="scope.row.customerid">
              <el-button
                type="text"
                size="mini"
                @click="goodsEdit(scope.$index, scope.row)"
                >编辑</el-button
              >
              <el-button
                size="mini"
                type="text"
                style="color: red"
                @click="delGoodItem(scope.$index, scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="qdBtn TB_center" style="width: 100%; margin-top: 50px">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            layout="prev, pager, next"
            :total="goodslisttotal"
          ></el-pagination>
        </div>
        <div class="qdBtn TB_center" style="width: 100%; margin-top: 50px">
          <el-button type="primary" @click="setGoodspush()">确认选择</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 新增编辑商品弹窗 -->
    <el-dialog title="商品新增" :visible.sync="goodstextShow" width="850px">
      <div style="width: 100%">
        <el-form
          size="small"
          ref="addgoodform"
          :model="addgoodform"
          :rules="goodsRules"
          label-width="110px"
          class="goodsTextFlex"
        >
          <div style="width: 45%">
            <el-form-item style="width: 100%" label="中文品名" prop="namec">
              <el-input
                placeholder="请输入中文品名"
                v-model="addgoodform.namec"
              ></el-input>
            </el-form-item>
            <el-form-item
              prop="goodstypeid"
              style="width: 100%"
              label="商品类型"
            >
              <el-select
                clearable
                style="width: 100%"
                ref="changeFBAgoodtype"
                placeholder="请选择商品类型"
                v-model="addgoodform.goodstypeid"
              >
                <el-option
                  v-for="res in goodstypelist"
                  :key="res.id"
                  :label="res.cnName"
                  :value="res.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item style="width: 100%" label="品牌" prop="brand">
              <el-input
                placeholder="请输入商品品牌"
                v-model="addgoodform.brand"
              ></el-input>
            </el-form-item>
            <el-form-item style="width: 100%" label="海关编码" prop="hsCode">
              <el-input
                placeholder="请输入海关编码"
                v-model="addgoodform.hsCode"
              ></el-input>
            </el-form-item>
            <el-form-item style="width: 100%" label="用途" prop="purposec">
              <el-input
                style="width: 100%"
                placeholder="请输入用途"
                v-model="addgoodform.purposec"
              ></el-input>
            </el-form-item>
            <el-form-item
              style="width: 100%"
              label="是否带磁"
              prop="isHasMagnetic"
            >
              <el-select
                style="width: 100%"
                v-model="addgoodform.isHasMagnetic"
                placeholder="请选择"
              >
                <el-option label="是" :value="true"> </el-option>
                <el-option label="否" :value="false"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item style="width: 100%" label="销售链接" prop="salesUrl">
              <el-input
                placeholder="请输入销售链接"
                v-model="addgoodform.salesUrl"
              ></el-input>
            </el-form-item>
            <el-form-item style="width: 100%" label="图片上传" prop="picUrl">
              <el-upload
                ref="uploadDemo"
                drag
                multiple
                class="upload-demo"
                :action="''"
                :limit="1"
                :show-file-list="false"
                :auto-upload="false"
                accept="image/jpeg,image/jpg,image/png"
                :on-change="handleAvatarChange"
              >
                <img
                  v-if="addgoodform.picUrl"
                  :src="addgoodform.picUrl"
                  class="avatar"
                />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </div>
          <div style="width: 45%">
            <el-form-item prop="namee" style="width: 100%" label="英文品名">
              <el-input
                style="width: 100%"
                placeholder="请输入英文品名"
                v-model="addgoodform.namee"
              ></el-input>
            </el-form-item>
            <el-form-item style="width: 100%" label="型号" prop="model">
              <el-input
                placeholder="请输入商品型号"
                v-model="addgoodform.model"
              ></el-input>
            </el-form-item>
            <el-form-item
              style="width: 100%"
              label="货值(USD)"
              prop="declaredValue"
            >
              <el-input
                placeholder="请输入商品货值"
                type="number"
                v-model.number="addgoodform.declaredValue"
              ></el-input>
            </el-form-item>
            <el-form-item style="width: 100%" label="材质" prop="materialc">
              <el-input
                placeholder="请输入材质"
                v-model="addgoodform.materialc"
              ></el-input>
            </el-form-item>
            <el-form-item
              style="width: 100%"
              label="是否带电"
              prop="isHasBattery"
            >
              <el-select
                style="width: 100%"
                v-model="addgoodform.isHasBattery"
                placeholder="请选择"
              >
                <el-option label="是" :value="true"> </el-option>
                <el-option label="否" :value="false"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              style="width: 100%"
              label="是否液体/粉末"
              prop="isPowderLiquid"
            >
              <el-select
                style="width: 100%"
                v-model="addgoodform.isPowderLiquid"
                placeholder="请选择"
              >
                <el-option label="是" :value="true"> </el-option>
                <el-option label="否" :value="false"> </el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-form>
        <div
          style="width: 100%; padding: 30px; box-sizing: border-box"
          class="TB_center"
        >
          <el-button type="primary" @click="addgoodtext('addgoodform')">{{
            GoodsCategory ? "确认新增" : "确认修改"
          }}</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 新增编辑商品弹窗END -->
    <!-- Excel上传 -->
    <el-dialog title="文件上传" :visible.sync="excelVisible" width="40%" center>
      <el-upload
        style="text-align: center"
        :show-file-list="false"
        :on-error="handleError"
        :on-success="handleSuccess"
        :before-upload="handleBeforeUpload"
        :http-request="uploadSectionFile"
        class="upload-demo"
        drag
        action=""
        multiple
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      </el-upload>
      <div class="helper">如需提供帮助，请致电400-992-1818</div>
      <span slot="footer" class="dialog-footer">
        <el-button
          style="margin-right: 20px"
          size="mini"
          @click="excelVisible = false"
          >取 消</el-button
        >
        <el-link target="_blank">
          <el-button size="mini" type="success" @click="Getdown()"
            >下载模板</el-button
          >
        </el-link>
      </span>
      <template>
        <el-table
          v-show="errorLabel.length > 0"
          :data="errorLabel"
          size="mini"
          border
          style="width: 100%"
        >
          <el-table-column align="center" width="50" type="index" label="序号">
          </el-table-column>
          <el-table-column
            align="center"
            width="80"
            prop="order"
            label="错误行"
          >
          </el-table-column>
          <el-table-column label="错误描述">
            <template slot-scope="scope">
              <span style="color: red">{{ scope.row.desc }}</span>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </el-dialog>

    <!-- Excel-19位上传 -->
    <!-- <el-dialog
      title="文件上传"
      :visible.sync="excelVisibleUpadte"
      width="40%"
      center
    >
      <el-upload
        style="text-align: center"
        :show-file-list="false"
        :on-error="handleErrorUpdate"
        :on-success="handleSuccessUpdate"
        :before-upload="handleBeforeUploadXls"
        :http-request="uploadSectionFileUpdate"
        class="upload-demo"
        drag
        action=""
        multiple
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      </el-upload>
      <div class="helper">如需提供帮助，请致电400-992-1818</div>
      <span slot="footer" class="dialog-footer">
        <el-button
          style="margin-right: 20px"
          size="mini"
          @click="excelVisibleUpadte = false"
          >取 消</el-button
        >
        <el-link target="_blank">
          <el-button size="mini" type="success" @click="Getdown()"
            >下载模板</el-button
          >
        </el-link>
      </span>
      <template>
        <el-table
          v-show="errorLabel.length > 0"
          :data="errorLabel"
          size="mini"
          border
          style="width: 100%"
        >
          <el-table-column align="center" width="50" type="index" label="序号">
          </el-table-column>
          <el-table-column
            align="center"
            width="80"
            prop="order"
            label="错误行"
          >
          </el-table-column>
          <el-table-column label="错误描述">
            <template slot-scope="scope">
              <span style="color: red">{{ scope.row.desc }}</span>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </el-dialog> -->

    <!-- 示例图 -->
    <el-dialog title="示例图" :visible.sync="imagesType" width="600px" center>
      <img
        v-show="imageNum == 1"
        src="../../../../../static/images/boxdemo.png"
        alt="FBA纸箱编号示例图"
      />
      <img
        v-show="imageNum == 2"
        src="../../../../../static/images/ponum.png"
        alt="补/发货示例图"
      />
    </el-dialog>
  </div>
</template>

<script>
import qs from "qs";
import { GoodsformCheck, BoxformCheck } from "./fromCheck.js"; //商品表单校验
export default {
  mixins: [GoodsformCheck, BoxformCheck],
  props: {
    LocahouseDTO: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      excelVisibleUpadte: false,
      imagesType: false,
      PathCBM: 0,
      errorLabel: [],
      upUrl: "",
      excelVisible: false,
      toFABck: {},
      addgoodform: {
        id: "",
        brand: "",
        customerid: "",
        declaredValue: "",
        goodstypeid: "",
        hsCode: "",
        materialc: "",
        materiale: "",
        namec: "",
        namee: "",
        purposec: "",
        purposee: "",
        model: "",
        salesUrl: "",
        isHasBattery: false,
        isPowderLiquid: false,
        isHasMagnetic: false,
        picUrl: "",
      },
      goodslisttotal: 0,
      goodsLabel: [],
      thatGoodslist: [],
      ThatgoodsID: "",
      goodstypelist: [],
      goodsTypeShow: false,
      pageNum: 1,
      billType: null,
      countLIst_T: {
        address: "",
        area: "",
        city: "",
        customerid: "",
        id: "",
        isdefault: null,
        name: "",
        parvince: "",
        tag: "",
        tel: "",
      },
      Sgodname: "",
      thatindexgslist: [],
      BoxWrapindex: null,
      imageNum:1,
      ruleform: {
        formLIst: [
          {
            goodstypeid: "", //货物类型
            typeName: "", //货物类型名字
            weight: "", //重量
            length: "", //长
            width: "", //宽
            height: "", //高
            shopName: "", //商户号
            poTrackingNo: "", //po追踪号
            fbxBoxNo: "", //箱号
            cbm: 0,
            goodsDTOList: [],
          },
        ],
      },
      goodstextShow: false,
      GoodsCategory: true,
      towarehouseid:sessionStorage.getItem("towarehouseid"),
    };
  },

  computed: {
    activeName() {
      let activeName = [];
      this.ruleform.formLIst.forEach((item, index) => {
        activeName.push(index);
      });
      this.activeLIst = activeName;
      return activeName;
    },
  },
  watch: {
    LocahouseDTO: function (val) {
      this.ruleform.formLIst = val.busFbxjobsBeforeBoxDTOList;
      this.toFABck = val.recwarehouseDTO;
      if (this.toFABck.type == 1 && this.toFABck.countryCode == "SA") {
        //需要校验
        this.billType = true; //显示 商铺号和追踪号
        // this.moreNotOjb.Notponum[0].required = true;
        // this.moreNotOjb.Notgoodsnum[0].required = true;
        this.moreNotOjb.Notboxnum[0].required = true;
      } else if (
        (this.toFABck.type == 1 && this.toFABck.countryCode != "SA") ||
        (this.toFABck.type == 1 && this.toFABck.countryCode != "US")
      ) {
        this.billType = true;
        // this.moreNotOjb.Notponum[0].required = true; //追踪号
        // this.moreNotOjb.Notgoodsnum[0].required = false; //商铺号
        this.moreNotOjb.Notboxnum[0].required = true; //箱号校验
      }

      if (this.toFABck.countryCode == "AE") {
        //阿联酋
        this.goodsRules.brand[0].required = false;
        this.goodsRules.hsCode[0].required = false;
        this.goodsRules.purposec[0].required = false;
        this.goodsRules.materialc[0].required = false;
        this.goodsRules.model[0].required = false;
        this.goodsRules.picUrl[0].required = false;
      }
      if (this.toFABck.countryCode == "SA") {
        //沙特
        this.goodsRules.hsCode[0].required = false;
      }
    },
  },
  methods: {
    Getdown() {
      //下载模板
      this.axios
        .get(`/busFbx/downFBXBoxGoodsTemplate`, {
          responseType: "arraybuffer" /* 容显 */,
        })
        .then((res) => {
          console.log(res);
          if (res.status) {
            let a = document.createElement("a");
            let blob = new Blob([res.data]);
            let objectUrl = URL.createObjectURL(blob);
            a.setAttribute("href", objectUrl);
            a.setAttribute("download", "商品模板.xls");
            a.click();
            URL.revokeObjectURL(objectUrl); // 释放内存
          } else {
          }
        })
        .catch((res) => {});
    },
    //失败时的方法
    handleError(err) {
      this.$message.info(err.data);
    },
    //成功时的方法
    handleSuccess(response) {
      if (response.isSuccess) {
        this.$message.success(response.error);
        return;
      }
      this.$message.info(response.error);
    },
    // 上传前
    handleBeforeUpload(file) {
      console.log(file);
      // 校验
      let legalName = ["xlsx", "xls"];
      // 拿到后缀名
      let name = file.name.substring(
        file.name.lastIndexOf(".") + 1,
        file.name.length
      );
      if (legalName.includes(name)) {
        // console.log(legalName.includes(name));
      } else {
        this.$message.info("文件格式不对，仅限后缀xls文件");
        return false;
      }
    },
    //上传
    uploadSectionFile(params) {
      let towarehouseid = sessionStorage.getItem("towarehouseid");;
      // let boxNoType = 1;
      let form = new FormData();
      form.append("file", params.file);
      form.append("towarehouseid", towarehouseid);
      // form.append("boxNoType", boxNoType);
      this.axios
        .post(`/busFbx/uploadFbxJobsBoxInfo`, form)
        .then((res) => {
          console.log(res);
          if (res.data.code == -1) {
            this.errorLabel = res.data.data;
            this.$message.info(res.data.data);
          } else {
            this.ruleform.formLIst = res.data.datas;
            this.excelVisible = false;
            this.getTimoney(); //重新计算提货费
            this.getFBATrans(); //重新计算运输费
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    Changehandle() {
      //计算增值服务费
      this.$refs["ruleform"].validate((valid) => {
        let File = true;
        if (valid) {
          try {
            this.ruleform.formLIst.forEach((item, index) => {
              if (item.goodsDTOList.length == 0) {
                File = false;
                throw this.$message({
                  message: `请添加${index + 1}号箱子内商品信息`,
                });
              }
              item.goodsDTOList.forEach((_item) => {
                if (_item.num == 0 || _item.num == null) {
                  File = false;
                  throw this.$message({ message: `添加的商品数量不能为0` });
                }
                if (!_item.declaredValue) {
                  File = false;
                  throw this.$message({ message: `请添加商品货值` });
                }
              });
            });
          } catch (err) {
            File = false;
          }
          if (File) {
            this.$emit("GetformType", File);
            this.$emit("getBoxformLIst", this.ruleform.formLIst);
          }
        } else {
          items.checked = false;
        }
      });
      //计算费用
    },
    getFBATrans() {
      //运输费
      this.$emit("getFBATrans", this.ruleform.formLIst);
    },
    getTimoney() {
      //获取提货费
      this.$emit("getTimoney", this.ruleform.formLIst);
    },

    setGoodspush() {
      if (this.thatGoodslist.length == 0) return this.$message("请选择商品");
      let newarray = this.thatindexgslist.concat(this.thatGoodslist);
      let idlist = [];
      newarray.forEach((item) => {
        idlist.push(item.goodstypeid);
      });
      idlist = [...new Set(idlist)];
      if (idlist.length > 1)
        return this.$message("单箱内只能放入同一种货物类型");

      let arr1 = JSON.parse(
        JSON.stringify(this.ruleform.formLIst[this.BoxWrapindex].goodsDTOList)
      );
      this.thatGoodslist.forEach((item) => {
        arr1.push(item);
      });

      let newArr = [];
      arr1.forEach((el) => {
        const result = newArr.findIndex((ol) => {
          return el.id === ol.id;
        });
        if (result !== -1) {
          newArr[result].num = newArr[result].num + el.num;
        } else {
          newArr.push(el);
        }
      });

      if (this.toFABck.countryCode == "SA") {
        if (newArr.length > 3)
          return this.$message("单箱子内商品类型不能超过3件");
      }

      this.goodsTypeShow = false;
      this.ruleform.formLIst[this.BoxWrapindex].goodsDTOList = newArr;
      this.ruleform.formLIst[this.BoxWrapindex].goodstypeid =
        newArr[0].goodstypeid;
      this.ruleform.formLIst[this.BoxWrapindex].typeName = newArr[0].goodstype;
      this.$emit("getFBATrans", this.ruleform.formLIst);
    },
    addItem(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let File = true;
          try {
            this.ruleform.formLIst.forEach((item, index) => {
              if (item.goodsDTOList.length == 0)
                throw this.$message({
                  message: `请添加${index + 1}号箱子内商品信息`,
                });
              item.goodsDTOList.forEach((_item) => {
                if (_item.num == 0 || _item.num == null) {
                  throw this.$message({ message: `添加的商品数量不能为0` });
                }
                if (!_item.declaredValue)
                  throw this.$message({ message: `请添加商品货值` });
              });
            });
          } catch (err) {
            File = false;
          }
          if (File) {
            this.activeName = [];
            this.ruleform.formLIst.push({
              goodstypeid: "", //货物类型
              typeName: "",
              weight: "", //重量
              length: "", //长
              width: "", //宽
              height: "", //高
              shopName: "", //商户号
              poTrackingNo: "", //po追踪号
              fbxBoxNo: "", //箱号
              cbm: 0,
              goodsDTOList: [],
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    goodsEdit(index, item) {
      console.log(item);
      this.GoodsCategory = false;
      this.goodstextShow = true;
      this.addgoodform.id = item.id;
      this.addgoodform.brand = item.brand;
      this.addgoodform.customerid = item.customerid;
      this.addgoodform.declaredValue = item.declaredValue;
      this.addgoodform.goodstypeid = item.goodstypeid;
      this.addgoodform.hsCode = item.hsCode;
      this.addgoodform.materialc = item.materialc;
      this.addgoodform.materiale = item.materiale;
      this.addgoodform.namec = item.namec;
      this.addgoodform.namee = item.namee;
      this.addgoodform.purposec = item.purposec;
      this.addgoodform.purposee = item.purposee;
      this.addgoodform.model = item.model;
      this.addgoodform.salesUrl = item.salesUrl;
      this.addgoodform.isHasBattery = item.isHasBattery;
      this.addgoodform.isPowderLiquid = item.isPowderLiquid;
      this.addgoodform.isHasMagnetic = item.isHasMagnetic;
      this.addgoodform.file = "";
      this.addgoodform.picUrl = item.picUrl;
    },
    handleAvatarChange(file) {
      //图片上传
      this.delImg(); //清空文件
      const isJPG = file.raw.type === "image/jpeg";
      const isPNG = file.raw.type === "image/png";
      const isLt2M = file.raw.size / 1024 / 1024 < 0.5;
      if (!isPNG && !isJPG) {
        this.$message.error("上传头像图片只能是 JPG/PNG 格式!");
        return false;
      } else if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 200kb!");
        return false;
      } else if (isLt2M && (isPNG || isJPG)) {
        this.imageFile = file;
        this.addgoodform.picUrl = URL.createObjectURL(file.raw);
        this.addgoodform.file = file.raw;
        return isLt2M && (isPNG || isJPG);
      }
    },
    addgoodtext(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {
            brand: this.addgoodform.brand,
            customerid: this.sessionGetUserInfo()
              .customerid, //客户id,
            declaredValue: this.addgoodform.declaredValue,
            file:
              typeof this.addgoodform.file == "undefined"
                ? null
                : this.addgoodform.file,
            goodstypeid: this.addgoodform.goodstypeid,
            hsCode: this.addgoodform.hsCode,
            id: this.addgoodform.id,
            isHasBattery: this.addgoodform.isHasBattery,
            isHasMagnetic: this.addgoodform.isHasMagnetic,
            isPowderLiquid: this.addgoodform.isPowderLiquid,
            materialc: this.addgoodform.materialc,
            model: this.addgoodform.model,
            namec: this.addgoodform.namec,
            namee: this.addgoodform.namee,
            picUrl: this.addgoodform.picUrl,
            purposec: this.addgoodform.purposec,
            salesUrl: this.addgoodform.salesUrl,
          };
          const formData = new FormData();
          for (const key in params) {
            formData.append(key, params[key]);
          }
          this.axios
            .post(`/busFbx/addOrUpdateFbxCustomerGoodsCategory`, formData, {
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
              },
            })
            .then((res) => {
              if (res.data.code == "200") {
                this.goodstextShow = false;
                this.getgoodsData();
                this.$message({
                  message: "成功",
                  type: "success",
                });
              } else {
                this.$message({
                  message: res.data.message,
                  type: "info",
                });
              }
            })
            .catch((res) => {});
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNum = val;
      this.getgoodsData();
    },
    changegoods(index) {
      this.Sgodname = "";
      this.thatindexgslist = [];
      if (this.ruleform.formLIst[index].goodsDTOList.length > 0) {
        //if 当前箱子内有货物
        this.ruleform.formLIst[index].goodsDTOList.forEach((item) => {
          this.thatindexgslist.push(item);
        });
      } else {
        this.thatindexgslist = [];
      }
      this.BoxWrapindex = index;
      this.getgoodsData();
      this.goodsTypeShow = true;
    },
    clone(box) {
      console.log("box: ");

      this.$refs["ruleform"].validate((valid) => {
        let boxItem = JSON.parse(JSON.stringify(box));
        boxItem.fbxBoxNo = "";
        if (valid) {
          this.ruleform.formLIst.push(JSON.parse(JSON.stringify(boxItem)));
          this.$emit("getTimoney", this.ruleform.formLIst); //重新计算提货费
          this.$emit("getFBATrans", this.ruleform.formLIst);
        } else {
          this.$message({
            type: "info",
            message: "请填充完整箱子信息",
          });
          return false;
        }
      });
    },
    delBoxgood(index, _index) {
      //删除箱子内某个商品
      this.ruleform.formLIst[index].goodsDTOList.splice(_index, 1);
    },
    handleDelete(index) {
      //删除箱子信息
      this.$confirm("确定删除该箱子信息吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.ruleform.formLIst.splice(index, 1);
          this.$emit("getFBATrans", this.ruleform.formLIst);
          this.$emit("getTimoney", this.ruleform.formLIst);
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleSelectionChange(val) {
      this.thatGoodslist = val;
    },

    getgoodsData(name) {
      //获取商品列表
      let params = {
        customerid: this.sessionGetUserInfo()
          .customerid, //客户id,
        goodstypeid: this.ThatgoodsID,
        name: name,
        towarehouseid: this.towarehouseid,
        pageNum: this.pageNum,
        pageSize: 10,
      };
      this.axios
        .post(`/busFbx/getFbxCustomerGoodsCategoryList`, params)
        .then((res) => {
          if (res.data.code == "200") {
            console.log(res);
            res.data.data.list.forEach((item) => {
              this.$set(item, "num", 1);
            });
            this.goodsLabel = res.data.data.list;
            this.goodslisttotal = res.data.data.total;
          } else {
          }
        })
        .catch((res) => {});
    },
    delImg() {
      //清空图片
      this.$refs.uploadDemo.clearFiles();
      this.addgoodform.picUrl = "";
      this.addgoodform.file = null;
    },
    addgoods() {
      //新增商品信息
      this.goodstextShow = true;
      this.GoodsCategory = true;
      this.addgoodform.id = "";
      this.addgoodform.brand = "";
      this.addgoodform.customerid = "";
      this.addgoodform.declaredValue = "";
      this.addgoodform.goodstypeid = "";
      this.addgoodform.hsCode = "";
      this.addgoodform.materialc = "";
      this.addgoodform.materiale = "";
      this.addgoodform.namec = "";
      this.addgoodform.namee = "";
      this.addgoodform.purposec = "";
      this.addgoodform.purposee = "";
      this.addgoodform.sku = "";
      this.addgoodform.isHasBattery = false;
      this.addgoodform.isPowderLiquid = false;
      this.delImg();
    },
    clickme(item) {},
    getGoodstypelist() {
      //商品类型
      // let params = {
      //   warehouseId: this.toFABck.id,
      // };
      this.axios
        .get(`/filedata/findFBAGoodTypeList?warehouseId=${this.towarehouseid}`)
        .then((res) => {
          if (res.data.code == "200") {
            this.goodstypelist = res.data.datas;
          } else {
          }
        })
        .catch((res) => {});
    },

    //19失败时的方法
    // handleErrorUpdate(err) {
    //   this.$message.info(err.data);
    // },
    // //19成功时的方法
    // handleSuccessUpdate(response) {
    //   if (response.isSuccess) {
    //     this.$message.success(response.error);
    //     // this.getListByParam();
    //     return;
    //   }
    //   this.$message.info(response.error);
    // },
    // // 19上传前
    // handleBeforeUploadXls(file) {
    //   // 校验
    //   let legalName = ["xlsx", "xls"];
    //   // 拿到后缀名
    //   let name = file.name.substring(
    //     file.name.lastIndexOf(".") + 1,
    //     file.name.length
    //   );
    //   if (legalName.includes(name)) {
    //     // console.log(legalName.includes(name));
    //   } else {
    //     this.$message.info("文件格式不对，仅限后缀xls文件");
    //     return false;
    //   }
    // },

    // //上传 19
    // uploadSectionFileUpdate(params) {
    //   let towarehouseid = sessionStorage.getItem("towarehouseid");;
    //   let boxNoType = 2;
    //   let form = new FormData();
    //   form.append("file", params.file);
    //   form.append("towarehouseid", towarehouseid);
    //   form.append("boxNoType", boxNoType);
    //   this.axios
    //     .post(`/busFbx/uploadFbxJobsBoxInfo`, form)
    //     .then((res) => {
    //       if (res.data.code == -1) {
    //         this.errorLabel = res.data.data;
    //         this.$message.info(res.data.data);
    //       } else {
    //         this.ruleform.formLIst = res.data.datas;
    //         this.excelVisibleUpadte = false;
    //         this.getTimoney(); //重新计算提货费
    //         this.getFBATrans(); //重新计算运输费
    //       }
    //     })
    //     .catch((res) => {
    //       console.log(res);
    //     });
    // },
  },
  created() {
    
  },
  mounted() {
    this.getGoodstypelist();
    this.towarehouseid=sessionStorage.getItem("towarehouseid");
  },
};
</script>
<style scoped>
.helper {
  width: 100%;
  height: 15%;
  color: #FF4D01;
  align-content: center;
  text-align: center;
  font-size: 20px;
}

.box-card {
  position: relative;
}
.cardWrap {
  padding: 0 0 0 44px;
}
.card_header {
  padding: 10px 20px;
  width: 100%;
  box-sizing: border-box;
}
.card_count {
  padding: 20px 20px 0 20px;
}
.header_logo {
  height: 30px;
  line-height: 30px;
  margin-left: 4px;
  color: #fff;
  position: absolute;
  top: 11px;
  right: 0px;
  border-radius: 20px 0px 0px 20px;
  background: #FF4D01;
  font-weight: bold;
  border-style: none none solid solid;
  /* border-color: #83a4fe;
  border-width: 3px; */
  z-index: 999;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
  box-sizing: border-box;
}
.LR_center {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
}
.addStyle {
  padding: 10px 0;
  box-sizing: border-box;
}
.boxindex {
  position: absolute;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background: #FF4D01;
  text-align: center;
  top: 10px;
  left: -17px;
  color: #ffffff;
  line-height: 25px;
  font-size: 18px;
  text-align: center;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.goodsTextFlex {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
}
.goodLi {
  width: 100%;
  height: 30px;
  padding: 0px;
}
.handNumber >>> .el-input__inner {
  border-radius: 20px !important;
  height: 24px !important;
  width: 100px !important;
  text-align: center;
}
/* 去除 number类型 的自带默认箭头 */
.handNumber >>> .el-input__inner::-webkit-outer-spin-button,
.handNumber >>> .el-input__inner::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
.handNumber >>> .el-input__inner[type="number"] {
  -moz-appearance: textfield;
}
.goodsValue >>> .el-input__inner {
  border-radius: 0 !important;
  height: 24px !important;
  width: 100px !important;
  text-align: center;
  border: none;
  border-bottom: 1px solid #9999;
}
.cloneType {
  color: #ffffff;
  float: left;
}
.deleteBtn {
  cursor: pointer;
  transition: all 0.2s ease-out;
  font-size: 18px;
  color: #ffffff;
  font-weight: bold;
  margin-left: 15px;
}

.Shipment {
  position: absolute;
  top: 20px;
}

.ShipmentID {
  position: absolute;
  top: 66px;
}
</style>



// WEBPACK FOOTER //
// src/components/PersonalCenter/FBAheader/FBAChangedata/Boxdata.vue